import React from 'react';
import { Grid, makeStyles } from 'e100-react-components';
import { Typography } from 'shared/components';

import { EmailInput } from './EmailInput';
import { Consent } from './Consent';
import { useIntl } from 'react-intl';
const useStyles = () =>
  makeStyles(({ spacing }) => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      width: 'fit-content',
      gap: spacing(2),
    },
    spacing: {
      marginBottom: spacing(2),
    },
  }))();

export const EmailConsent = () => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  return (
    <Grid container>
      <Grid item xs={12} classes={{ root: classes.spacing }}>
        <Typography variant="subtitle1">
          <b>{formatMessage({ id: 'pleaseProvideEmailForActivationConfirmationAndFeedback' })}</b>
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <div className={classes.container}>
          <EmailInput />
          <Consent />
        </div>
      </Grid>
    </Grid>
  );
};
